<script>
    import { format } from 'd3-format';
    // Components
    import RegionMap from './RegionMap.svelte';
    import Legend from './Legend.svelte';
    import Tooltip from './Tooltip.svelte';
    import { clamp } from '../utils/clamp';

    // d3
    import { scaleThreshold } from "d3-scale";

    export let data;
    export let title;
    export let showTitle;
    export let legendHeight;
  
    let waterData = data.map((d) => ({
      region: d.hydrologic_region,
      value: d.cumulative_pct_change,
    }));

    // colors
    let scheme = [
        '#829eb1', 
        '#a4b7c8', 
        '#dadfe2', 
        '#f9e58c', 
        '#f7bb4f', 
        '#ec8431'
    ]
    let thresholds = scaleThreshold()
        .domain([-.10,-.05,0,.05,.10])
        .range(scheme);
    //   .domain([-.15,-.10,-.05,0,.05,.10,.15])
    //   .range(
    //     ['#829eb1', '#a4b7c8', '#dadfe2', '#ecefee', '#fbf3b8','#f9e58c', '#f7bb4f', '#ec8431']
    //    );
    let color = (v) => (v != undefined ? thresholds(v) : '#dddddd');

    let percentFormatter = format('.0%');
    let legendFormatter = (i, scale) => percentFormatter(scale[i]);


  let tooltipSlug = 'tooltip__region-map';
  let tooltipHeader = '';
  let tooltipSubhed = '';
  let tooltipValues = [];
  let showTooltip = false;
  const tooltipLookup = waterData.reduce((obj, item) => {
    obj[item.region] = item;
    return obj;
  }, {});
  function handleMapActivateCounty(e, push = 20) {
    showTooltip = true;
    const region = e.detail.region;
    const tooltipData = tooltipLookup[region] || {};
    tooltipHeader = e.detail.region;
    tooltipSubhed = '';

    let value;

    if (tooltipData.value == undefined) {
        value = [`No data.`]
    } else if ( tooltipData.value > 0.005 ) {
        value = `Between July 2021 and March 2023, water use has <b style="padding: 3px; background:${thresholds(tooltipData.value)};">increased by ${(
            tooltipData.value * 100
          ).toFixed(1)}%</b> compared with 2020.`;
    } else if ( tooltipData.value < -0.005 ) {
        value = `Between July 2021 and March 2023, water use has <b style="padding: 3px; background:${thresholds(tooltipData.value)};">decreased by ${(
            Math.abs(tooltipData.value) * 100
          ).toFixed(1)}%</b> compared with 2020.`;
    } else  {
        value = `Between July 2021 and March 2023, water use has stayed about the same compared with 2020.`;
    }


    tooltipValues = [value];
    const el = document.getElementById(tooltipSlug);
    const { width, height } = el.getBoundingClientRect();
    const innerWidth = window.innerWidth;
    const innerHeight = window.innerHeight;
    const x = event.clientX;
    const y = event.clientY;
    const left = clamp(x - width / 2, push, innerWidth - width - push);
    const top =
      innerHeight > y + push * 2 + height ? y + push : y - height - push;
    el.style.left = `${left}px`;
    el.style.top = `${top}px`;
  }
  function handleMapDeactivateCounty(e) {
    showTooltip = false;
  }
  </script>
  
  <div class="svg-container">
    {#if showTitle }
        <div class="chart-headline">{title}</div>
    {/if}
  <div class="legend">
      <Legend
        height="{legendHeight}"
        color={thresholds}
        title="Percentage change between July 2021 and March 2023"
        tickFormatFunc={legendFormatter}
      />
    </div>      
    <RegionMap
      data={waterData}
      colorScale={color}
      on:mapActivateCounty={handleMapActivateCounty}
      on:mapDeactivateCounty={handleMapDeactivateCounty}        
      />
  <Tooltip
      slug={tooltipSlug}
      bind:showTooltip
      bind:header={tooltipHeader}
      bind:subhead={tooltipSubhed}
      bind:values={tooltipValues}
    />   
</div>
